export enum DesignOptionKey {
  DESIGN_COLOR = "Design Color",
}
export interface ColorSwatchesValue {
  key: string;
  name: string;
  currentColorSwatch?: boolean;
}
export interface ColorSwatches {
  key: string;
  name: string;
  options?: ColorSwatchesValue[];
}

export enum SelectionType {
  TEXT_BUTTONS = "Text buttons",
  SWATCHES = "Swatches",
  DROPDOWN = "Dropdown",
  TEXT_BOX = "Text box",
}
export const colorTranslation: Record<string, string> = {
  "en-US": "Colors",
  "es-US": "Colores",
  "fr-CA": "Couleurs",
  "en-CA": "Colours",
} as const;
